import { Providers, ProvidersType } from 'modules/SlotsRoot/types/configuration'
import { ISlotDTO } from 'modules/SlotsRoot/types/interfaces/Slots/GameCatalog'

export const getAdditionalIntegrationGameId = (provider: ProvidersType, slot: ISlotDTO) => {
  switch (provider) {
    case Providers.SOFTGAMING:
      return slot.slug.split(':')[0].split('/').join(':')
    case Providers.KELT_GAMES:
      return slot.slug
    default:
      return slot.game_id
  }
}

export const renameProducerForKeltgamesStart: Record<string, string> = {
  pragmaticplay: 'pragmatic',
  pragmaticplaylive: 'pragmatic',
}
